import type { RouteRecordRaw } from 'vue-router';

import type { FunnelId } from './config';

export interface FunnelPageOverride {
  component: () => Promise<unknown>;
  meta?: RouteRecordRaw['meta'];
}

const EMAIL_LANDING_META = { layout: 'email-landing-layout' };

export const FUNNEL_PAGE_OVERRIDES: Partial<Record<FunnelId, Record<string, FunnelPageOverride>>> = {
  google: {
    'verify-email': {
      component: () => import('./google/pages/verify-email.vue'),
    },
  },
  retargeting: {
    index: {
      component: () => import('./retargeting/pages/index.vue'),
      meta: { layout: 'retargeting-layout', isStartPage: true },
    },
  },
  email: {
    index: {
      component: () => import('./email/pages/index.vue'),
    },
  },
};

export const FUNNEL_EXCLUSIVE_PAGES: Partial<Record<FunnelId, Record<string, FunnelPageOverride>>> = {
  email: {
    landing_email_v1: {
      component: () => import('./email/pages/landing_email_v1.vue'),
      meta: EMAIL_LANDING_META,
    },
    landing_email_v2: {
      component: () => import('./email/pages/landing_email_v2.vue'),
      meta: EMAIL_LANDING_META,
    },
    landing_email_v3: {
      component: () => import('./email/pages/landing_email_v3.vue'),
      meta: EMAIL_LANDING_META,
    },
    landing_email_v4: {
      component: () => import('./email/pages/landing_email_v4.vue'),
      meta: EMAIL_LANDING_META,
    },
    landing_email_v5: {
      component: () => import('./email/pages/landing_email_v5.vue'),
      meta: EMAIL_LANDING_META,
    },
  },
};

export function pageOverridesFor(funnel: FunnelId): Record<string, FunnelPageOverride> {
  return FUNNEL_PAGE_OVERRIDES[funnel] ?? {};
}

export function exclusivePagesFor(funnel: FunnelId): Record<string, FunnelPageOverride> {
  return FUNNEL_EXCLUSIVE_PAGES[funnel] ?? {};
}
